import { useContext } from 'react';
import { PortalsContext } from '../../contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import styled from 'styled-components';
import { ImpersonationBannerWrap } from './ImpersonatorBanner';
import Typography from '../../kingpin/atoms/Typography';
import Button from '../../kingpin/atoms/Button';
import Tooltip from '../Tooltip';
import NavItem from '../../kingpin/navigation/NavItem';

const BannerDiv = styled(ImpersonationBannerWrap)`
  background-color: var(--color-badge-info-bg);
  border: 1px solid var(--color-badge-info-border);
  margin-bottom: 8px;
  flex-direction: column;
  padding: 12px 16px;
`;

const NewUiPreviewBanner = ({ isOpen }: { isOpen: boolean }) => {
  const { isPortalUIToggleEnabled, isPortalsEnabled, onRevertToOldUiClicked } =
    useContext(PortalsContext);

  if (!isPortalsEnabled || !isPortalUIToggleEnabled) {
    return null;
  }

  if (!isOpen) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Tooltip content={'Use old layout'} isFlexAnchor>
          <NavItem
            iconColor={'var(--color-icon-secondary)'}
            to={'/'}
            label={''}
            icon={'ui'}
            onClick={onRevertToOldUiClicked}
          />
        </Tooltip>
      </div>
    );
  }

  return (
    <BannerDiv isOpen={isOpen}>
      {isOpen && (
        <div style={{ marginBottom: 4 }}>
          <Typography.Body type="Label">
            You are using our new layout
          </Typography.Body>
        </div>
      )}

      <div style={{ width: '100%' }}>
        <Button
          size={'Small'}
          type={'Danger Secondary'}
          label={'Use old layout'}
          onClick={onRevertToOldUiClicked}
        />
      </div>
    </BannerDiv>
  );
};

export default NewUiPreviewBanner;
